<div class="modal-header-modern">
    <div class="modal-header-icon icon-blue">
        <i class="material-icons">block</i>
    </div>
    <div>
        <h4 class="modal-title-modern">{{ bloqueioId ? 'Editar Bloqueio' : 'Novo Bloqueio' }}</h4>
        <p class="modal-subtitle-modern">Defina períodos em que sua agenda fica indisponível</p>
    </div>
    <button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
        <i class="material-icons">close</i>
    </button>
</div>

<div class="modal-body">
    <ngx-loading [show]="loading"></ngx-loading>

    <form [formGroup]="form" *ngIf="!loading">
        <div class="row">
            <mat-form-field class="col-md-12" appearance="outline">
                <mat-label>Tipo de bloqueio *</mat-label>
                <mat-select formControlName="tipo">
                    <mat-option *ngFor="let t of tipos" [value]="t.id">{{ t.nome }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- PONTUAL -->
        <ng-container *ngIf="+form.value.tipo === TipoEnum.Pontual">
            <div class="row">
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Data *</mat-label>
                    <input matInput [matDatepicker]="pickerPontual" formControlName="data" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerPontual"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPontual></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Hora início *</mat-label>
                    <input matInput type="time" formControlName="horaInicio">
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Hora fim *</mat-label>
                    <input matInput type="time" formControlName="horaFim">
                </mat-form-field>
            </div>
        </ng-container>

        <!-- DIA INTEIRO -->
        <ng-container *ngIf="+form.value.tipo === TipoEnum.DiaInteiro">
            <div class="row">
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Data do bloqueio *</mat-label>
                    <input matInput [matDatepicker]="pickerDiaInteiro" formControlName="data" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerDiaInteiro"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDiaInteiro></mat-datepicker>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- PERIODO -->
        <ng-container *ngIf="+form.value.tipo === TipoEnum.Periodo">
            <div class="row">
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Data inicial *</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoIni" formControlName="dataInicio" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoIni"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoIni></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Data final *</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoFim" formControlName="dataFim" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoFim"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoFim></mat-datepicker>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- RECORRENTE -->
        <ng-container *ngIf="+form.value.tipo === TipoEnum.Recorrente">
            <div class="row">
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Dia da semana *</mat-label>
                    <mat-select formControlName="diaSemanaRecorrente">
                        <mat-option *ngFor="let d of diasSemana" [value]="d.id">{{ d.nome }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Hora início *</mat-label>
                    <input matInput type="time" formControlName="horaInicioRecorrente">
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Hora fim *</mat-label>
                    <input matInput type="time" formControlName="horaFimRecorrente">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Início da vigência (opcional)</mat-label>
                    <input matInput [matDatepicker]="pickerVigIni" formControlName="vigenciaInicio" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerVigIni"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVigIni></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Fim da vigência (opcional)</mat-label>
                    <input matInput [matDatepicker]="pickerVigFim" formControlName="vigenciaFim" placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matSuffix [for]="pickerVigFim"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVigFim></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="info-hint">
                <i class="material-icons">info</i>
                <span>Se as datas de vigência ficarem em branco, o bloqueio recorrente vale por tempo indeterminado.</span>
            </div>
        </ng-container>

        <div class="row">
            <mat-form-field class="col-md-12" appearance="outline">
                <mat-label>Motivo (opcional)</mat-label>
                <input matInput formControlName="motivo" maxlength="200" placeholder="Ex: Almoço, Férias, Reunião">
                <mat-hint align="end">{{ form.get('motivo')?.value?.length || 0 }}/200</mat-hint>
            </mat-form-field>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn-modern btn-modern-outline" (click)="cancelar()" [disabled]="salvando || excluindo">
        Cancelar
    </button>
    <button class="btn-modern btn-modern-danger" *ngIf="bloqueioId && bloqueioId !== 0" (click)="excluir()" [disabled]="salvando || excluindo">
        <i class="material-icons">delete</i>
        <span *ngIf="!excluindo">Excluir</span>
        <span *ngIf="excluindo">Excluindo...</span>
    </button>
    <button class="btn-modern btn-modern-success" (click)="salvar()" [disabled]="salvando || excluindo || form.invalid">
        <i class="material-icons">save</i>
        <span *ngIf="!salvando">Salvar</span>
        <span *ngIf="salvando">Salvando...</span>
    </button>
</div>
